import { BeanBase, deepExtend } from 'zova';
export class BeanThemeBase extends BeanBase {
  getOptionsToken(params) {
    const options = this.$onionOptions;
    return options.token?.(params);
  }
  mergeOptionsToken(params, token) {
    const optionsToken = this.getOptionsToken(params);
    if (optionsToken) {
      token = deepExtend(token, optionsToken);
    }
    return token;
  }
}